import { useEffect, useState } from "react"
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  MenuItem,
  Select,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import UserAPI from "../../../../api/user"
import { useNavigate } from "react-router-dom"
import { getTokenLocal } from "../../../../helper/utils"
import { useResponseHandle } from "../../../hooks"

const userAPI = new UserAPI()
const ChangeRoleModal = (props: any) => {
  const { open, setOpen, type, fetchUserDetails, userUID } = props

  const token: any = getTokenLocal()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [isRolesCategoryDisabled, setIsRolesCategoryDisabled] = useState(false)
  const [roles, setRoles] = useState<Array<{ label: string; value: string }>>(
    [],
  )

  const fetchPossibleRoles = async () => {
    setIsRolesCategoryDisabled(true)
    setLoading(true)
    const response = await userAPI.getPossibleRole(token, userUID)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      setLoading(false)
      if (result?.statusCode == 200) {
        setRoleCategory(
          result?.data.map((item: any) => {
            return (
              (item.role_display_name = item.role_category.replace("_", " ")),
              item
            )
          }),
        )
        setIsRolesCategoryDisabled(false)
      }
    } else {
      navigate("/auth")
    }
  }

  useEffect(() => {
    userUID && fetchPossibleRoles()
  }, [userUID])

  const [roleCategory, setRoleCategory] = useState<Array<any>>([])
  const [activeRoleData, setActiveRoleData] = useState({
    roleCategory: "",
    roleId: "",
  })

  const handleChangeUserRole = (value: any, key: string) => {
    setActiveRoleData((prevState) => ({
      ...prevState,
      [key]: value,
    }))

    if (key === "roleCategory") {
      setRoles([])
      setActiveRoleData((prevState) => ({
        ...prevState,
        roleId: "",
      }))
      fetchRoles(value)
    }
  }

  const fetchRoles = async (roleCat: string) => {
    setLoading(true)

    const response = await userAPI.getRole(token, roleCat)
    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        setRoles(result?.data)
        setLoading(false)
      }
    } else {
      navigate("/auth")
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleClickSubmit = async () => {
    setLoading(true)

    const response = await userAPI.updateRole(
      token,
      userUID,
      activeRoleData.roleCategory,
      activeRoleData.roleId,
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
      }
    } else {
      navigate("/auth")
    }
    setLoading(false)
    fetchUserDetails()
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle
        sx={{
          borderBottom: "1px solid #e0e0e0",
          marginBottom: "1rem",
          display: "flex ",
          justifyContent: "space-between",
        }}
      >
        Update Role
        <IconButton sx={{ mr: 1 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ borderBottom: "1px solid #e0e0e0", width: "500px" }}>
        <DialogContentText sx={{ marginBottom: "10px" }}>
          Select a Role Category
        </DialogContentText>

        <Select
          value={activeRoleData.roleCategory}
          onChange={(e: any) =>
            handleChangeUserRole(e.target.value, "roleCategory")
          }
          sx={{ textTransform: "capitalize" }}
          fullWidth
          disabled={isRolesCategoryDisabled}
        >
          {roleCategory?.map((item: any) => {
            return (
              <MenuItem
                key={item.role_category}
                value={item.role_category}
                sx={{ textTransform: "capitalize" }}
              >
                {item.role_display_name}
              </MenuItem>
            )
          })}
        </Select>

        <DialogContentText sx={{ margin: "20px 0  10px 0" }}>
          Select Role
        </DialogContentText>
        <Select
          value={activeRoleData.roleId}
          onChange={(e) => handleChangeUserRole(e.target.value, "roleId")}
          fullWidth
          disabled={loading || activeRoleData.roleCategory === ""}
        >
          {!loading &&
            roles?.map((item: any) => (
              <MenuItem key={item.role_id} value={item.role_id}>
                {item.role_display_name}
              </MenuItem>
            ))}
        </Select>
      </DialogContent>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          padding: "20px",
        }}
      >
        <Button
          variant="outlined"
          fullWidth
          onClick={handleClose}
          sx={{ width: "fit-content", minWidth: "40px" }}
        >
          Cancel
        </Button>
        <Button
          disabled={
            loading ||
            activeRoleData.roleCategory === "" ||
            activeRoleData.roleId === ""
          }
          variant="contained"
          fullWidth
          onClick={handleClickSubmit}
          sx={{ width: "fit-content", minWidth: "40px" }}
          startIcon={loading && <CircularProgress size="1.5rem" />}
        >
          Confirm
        </Button>
      </Box>
    </Dialog>
  )
}

export default ChangeRoleModal